import React from "react";
import { Stack, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import MintButton from "../MintButton";

// ---------------------------------------------------------------------
const ContainerStyle = styled("div")(({ theme }) => ({
  padding: "20px",
  borderBottom: "1px solid #ffffff80",
}));

const TitleStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "70px",
  fontFamily: "Helvetica",
}));

const ContentStyle = styled("p")(({ theme }) => ({
  color: "#fff",
  fontSize: "20px",
  fontFamily: "Helvetica",
  lineHeight: 1.2,
}));

const TextFlowStyle = styled("div")(({ theme }) => ({
  overflow: "hidden",
  backgroundColor: "#fff",
  width: "100%",

  "@keyframes scrolling-left1": {
    "0%": {
      transform: "translateX(100%)",
    },
    "100%": {
      transform: "translateX(-100%)",
    },
  },

  "@keyframes scrolling-left2": {
    "0%": {
      transform: "translateX(0%)",
    },
    "100%": {
      transform: "translateX(-200%)",
    },
  },
}));

const TextFlowContentStyle = styled("p")(({ theme }) => ({
  fontFamily: "Helvetica",
  color: "#000",
  width: "100%",
  whiteSpace: "nowrap",
  padding: "8px 0",
}));

const TextAStyle = styled("span")(({ theme }) => ({
  fontSize: "20px",
  display: "inline-block",
  animation: "scrolling-left1 40s linear infinite",
}));

const TextBStyle = styled("span")(({ theme }) => ({
  fontSize: "20px",
  display: "inline-block",
  animation: "scrolling-left2 40s linear infinite",
  animationDelay: "20s",
}));

export default function MembersMobileContent({
  address,
  userSigner,
  localProvider,
  mainnetProvider,
  price,
  web3Modal,
  loadWeb3Modal,
  logoutOfWeb3Modal,
  blockExplorer,
  contract,
  remainTokenCount,
  remainMintCount,
  saleStatus,
}) {
  return (
    <Stack sx={{ mt: "90px" }}>
      <ContainerStyle>
        <TitleStyle sx={{ fontSize: "30px" }}>
          AN NFT MEMBERSHIP FOR THE CREATIVE COMMUNITY
        </TitleStyle>
      </ContainerStyle>
      <Stack>
        <Box
          component="img"
          src="/assets/RHOOD6.png"
          sx={{ height: "100%", objectFit: "cover" }}
        />
      </Stack>
      <ContainerStyle>
        <TitleStyle sx={{ fontSize: "20px", pb: 3 }}>
          Your R/HOOD NFT membership will be validated in the form of an
          illustration of you! This is a brand being built for the long term,
          and we want you to be on the journey with us. We chose a personalised
          illustration of each member to reflect how important each individual
          is in our community.
        </TitleStyle>
        <TitleStyle sx={{ fontSize: "20px", pb: 3 }}>
          We will create a total of 10, 000 memberships with characters and
          styles specific to local neighbourhoods. Around 33% of them will
          feature rare traits as an homage to all the Culture Makers that have
          shaped our community, and the wider world.
        </TitleStyle>
        <TitleStyle sx={{ fontSize: "20px", pb: 3 }}>
          Every month we will drop 100 new membership cards. These cards are for
          application-only members, as we want to curate an engaged and active
          community.
        </TitleStyle>
      </ContainerStyle>

      <TextFlowStyle>
        <TextFlowContentStyle>
          <TextAStyle>
            &nbsp;WELCOME TO OUR NEIGHBORHOOD WELCOME TO OUR NEIGHBORHOOD
          </TextAStyle>
          <TextBStyle>
            &nbsp;WELCOME TO OUR NEIGHBORHOOD WELCOME TO OUR NEIGHBORHOOD&nbsp;
          </TextBStyle>
        </TextFlowContentStyle>
      </TextFlowStyle>

      <ContainerStyle>
        <TitleStyle sx={{ fontSize: "30px" }}>
          A MISSION TO SHINE A LIGHT ON LOCAL TALENT, CREATORS AND COMMUNITIES
        </TitleStyle>
      </ContainerStyle>
      <Stack>
        <Box
          component="img"
          src="/assets/RHOOD5.png"
          sx={{ height: "100%", objectFit: "cover" }}
        />
      </Stack>

      <ContainerStyle>
        <TitleStyle sx={{ fontSize: "20px", pb: 3 }}>
          R/HOOD is the world's first on-chain creative neighbourhood, creating
          an off-chain community. R/HOOD is a creative curator and facilitator,
          supported by an NFT membership housed on the web3 open source
          infrastructure.
        </TitleStyle>
        <TitleStyle sx={{ fontSize: "20px", pb: 3 }}>
          After completing our 2023 roadmap, R/HOOD will be able to source
          music, art, and creative expression from local communities across the
          world. This will bring together unique and fruitful connections
          between people from across the world. It will form a new digital
          neighbourhood with local talent, on a global scale.
        </TitleStyle>
        <TitleStyle sx={{ fontSize: "20px", pb: 3 }}>
          Our mission is to shine a light on local talent, creators, and
          communities from various neighbourhoods across the globe, and
          introduce them to a global audience.
        </TitleStyle>
        <TitleStyle sx={{ fontSize: "20px", pb: 3 }}>
          We bridge the gap between IRL experiences and online communities.
        </TitleStyle>
      </ContainerStyle>

      <ContainerStyle>
        <TitleStyle>UTILITY</TitleStyle>
      </ContainerStyle>

      <Stack sx={{ p: 4 }}>
        <TitleStyle sx={{ fontSize: "22px", pb: 3 }}>
          IRL EVENTS. EXCLUSIVE CONTENT. LIMITED EDITION DROPS. SPECIAL EDITION
          MERCH. COLLABS.LIKE-MINDED PEOPLE. GIGS. DISCOUNTS. ART. MUSIC.
          PLACES. EXPERIENCES. MEMORIES. SUPPORT. ALLOWLIST. KNOWLEDGE. ALPHA.
        </TitleStyle>
        <Stack alignItems="center">
          <MintButton
            address={address}
            localProvider={localProvider}
            userSigner={userSigner}
            mainnetProvider={mainnetProvider}
            price={price}
            web3Modal={web3Modal}
            loadWeb3Modal={loadWeb3Modal}
            logoutOfWeb3Modal={logoutOfWeb3Modal}
            blockExplorer={blockExplorer}
            contract={contract}
            remainTokenCount={remainTokenCount}
            remainMintCount={remainMintCount}
            saleStatus={saleStatus}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
